<template>
  <div class="iheader">
    <div class="iheader_pad">
      <div class="iheaderp_d1">
        <a @click="toIndex" v-if="device !== 'mobile'">
          <img :src="require('~a/imgs/4.png')" />
        </a>
        <div class="iheaderpd1_d2">
          <ul>
            <li>
              <div class="iheaderpd1d2_top">
                <!-- <select class="searchSelect" v-model="selectedValue" @change="handleSelection">
                  <option value="1">农产品</option>
                  <option value="2">经典方</option>
                  <option value="3">植物药</option>
                </select> -->
                <el-dropdown class="searchSelect" trigger="click" >
                        <span class="el-dropdown-link">
                           {{selectedValue==1?'农产品':''}}{{selectedValue==2?'经典方':''}}{{selectedValue==3?'植物药':''}}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu  slot="dropdown" >
                            <el-dropdown-item @click.native="handleSelection(1)">农产品</el-dropdown-item>
                            <el-dropdown-item @click.native="handleSelection(2)">经典方</el-dropdown-item>
                            <el-dropdown-item @click.native="handleSelection(3)">植物药</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                <input
                  placeholder="请输入搜索关键字..."
                  @keydown.enter="seach()"
                  v-model="seachKey"
                />
                <a @click="seach">搜索</a>
              </div>
            </li>
            <li v-if="selectedValue == '1'">
              <div class="iheaderpd1d2_bot">
                <a @click="toSeach('乌猪肉')">乌猪肉</a>
                <a @click="toSeach('土鸡')">土鸡</a>
                <a @click="toSeach('鸡蛋')">鸡蛋</a>
                <a @click="toSeach('微压珐琅锅')">微压珐琅锅</a>
              </div>
            </li>
            <li v-if="selectedValue == '2'">
              <div class="iheaderpd1d2_bot">
                <a @click="toSeach('前胡汤')">前胡汤</a>
                <a @click="toSeach('十宝丹')">十宝丹</a>
                <a @click="toSeach('消湿散')">消湿散</a>
                <a @click="toSeach('补肺散')">补肺散</a>
              </div>
            </li>
            <li v-if="selectedValue == '3'">
              <div class="iheaderpd1d2_bot">
                <a @click="toSeach('枸骨叶')">枸骨叶</a>
                <a @click="toSeach('草乌头')">草乌头</a>
                <a @click="toSeach('乌药')">乌药</a>
                <a @click="toSeach('黄芪')">黄芪</a>
              </div>
            </li>
          </ul>
          <div class="iheaderp_d0" v-if="device == 'mobile'">
            <el-dropdown trigger="click">
              <img class="syimg" src="../../views/Home/img/菜单栏.png">
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toIndex()">商城首页</el-dropdown-item>
                  <el-dropdown-item @click.native="topRescription()">经典方</el-dropdown-item>
                  <el-dropdown-item @click.native="toExtract()">植物药</el-dropdown-item>
                  <el-dropdown-item @click.native="toChemicals()">中国药典</el-dropdown-item>
                  <el-dropdown-item @click.native="togoodsList()">农产品</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="iheaderpd1_d3" v-if="device !== 'mobile'">
          <div class="iheaderpd1d3_left">
            <a @click="toCar()">我的购物车</a>
          </div>
          <div class="iheaderpd1d3_right">
            <a @click="toCar()">
              <img src="../img/购物车空 (1).png" />
            </a>
          </div>
        </div>
        <div class="cartsize" v-if="device !== 'mobile'"><a>{{cartSize}}</a>  </div>
      
      </div>
      <div class="iheaderp_d2" v-if="device !== 'mobile'">
        <a
          :class="
            'iheaderpd2_a2' + (selectIndex == 1 ? ' iheaderpd2_a2_select' : '')
          "
          @click="toIndex()"
          >商城首页</a
        >
        <a
          :class="
            'iheaderpd2_a2' + (selectIndex == 2 ? ' iheaderpd2_a2_select' : '')
          "
          @click="topRescription()"
          >经典方</a
        >
        <a
          :class="
            'iheaderpd2_a2' + (selectIndex == 3 ? ' iheaderpd2_a2_select' : '')
          "
          @click="toExtract()"
          >植物药</a
        >
        <a
          :class="
            'iheaderpd2_a2' + (selectIndex == 4 ? ' iheaderpd2_a2_select' : '')
          "
          @click="toChemicals()"
          >中国药典</a
        >
        <a :class="'iheaderpd2_a2' + (selectIndex == 5 ? ' iheaderpd2_a2_select' : '')" @click="togoodsList()" >农产品</a
        >
      </div>
      <!-- <div class="iheaderp_d2" v-else>
          <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                  <img src="../../views/Home/img/search.png">
                  <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="toIndex()">商城首页</el-dropdown-item>
                  <el-dropdown-item @click.native="topRescription()">经典方</el-dropdown-item>
                  <el-dropdown-item @click.native="toExtract()">植物药</el-dropdown-item>
                  <el-dropdown-item @click.native="toChemicals()">中国药典</el-dropdown-item>
                  <el-dropdown-item @click.native="togoodsList()">农产品</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
        </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations,mapState } from "vuex";
import { toLogin } from "@/utils";
export default {
  data() {
    return {
      selectIndex: 1,
      seachKey: "",
      selectedValue:1,
    };
  },
  computed: {
    ...mapGetters(["device"]),
    ...mapGetters(["device", "userInfo", "userId"]),
    ...mapState(['cartSize']),
  },

  created: function () {},
  mounted: function () {
    if (this.$route.path === "/") {
      this.selectIndex = 1;
    }
    console.log(this.$route.path);
    if (this.$route.path === "/prescriptionDetail") {
      this.selectIndex = 2;
    }
    if (this.$route.path === "/extract" || this.$route.path === "/goodsDetail") {
      this.selectIndex = 3;
    }
    if (this.$route.path === "/chemicals" || this.$route.path === "/chemicalsDetail") {
      this.selectIndex = 4;
    }
    if (this.$route.path === "/goodsList" || this.$route.path === "/ncpgoodsdetail") {
      this.selectIndex = 5;
    }
    this.GetCartList();
  },
  methods: {
    ...mapMutations("goods", ["SET_SEACH_KEY"]),
    ...mapActions("app", ["toggleHomeClassifyShow"]),
    async GetCartList() {
      let res = await this.$post("GetCartList", {UserId: this.$store.state.userId,});
      this.$store.commit('updatecarSize', res.data.ResultData.length)
    },
    handleSelection(value){
      this.selectedValue = value;
      console.log(value);
        if(value == 1){
            this.$router.push("/goodslist");
            this.selectIndex = 5;
        }else if(value == 2){
            this.$router.push("/prescription");
            this.selectIndex = 2;
        }else if(value == 3){
            this.$router.push("/extract");
            this.selectIndex = 3;
        }
    },
    seach() {
        if(this.selectedValue == 1){
            this.SET_SEACH_KEY(this.seachKey);
            if (this.$route.path != "/goodsList") {
                this.$router.push("/goodsList");
            }
        }else if(this.selectedValue == 2){
            this.SET_SEACH_KEY(this.seachKey);
            if (this.$route.path != "/prescription") {
                this.$router.push("/prescription");
            }
        }else if(this.selectedValue == 3){
            this.SET_SEACH_KEY(this.seachKey);
            if (this.$route.path != "/extract") {
                this.$router.push("/extract");
            }
        }
    },
    toSeach(e) {
        this.seachKey = e;
        if(this.selectedValue == 1){
            this.SET_SEACH_KEY(this.seachKey)
            if (this.$route.path != "/goodsList") {
                this.$router.push("/goodsList")
            }
        }else if(this.selectedValue == 2){
            this.SET_SEACH_KEY(this.seachKey)
            if (this.$route.path != "/prescription") {
                this.$router.push("/prescription")
            }
        }else if(this.selectedValue == 3){
            this.SET_SEACH_KEY(this.seachKey)
            if (this.$route.path != "/extract") {
                this.$router.push("/extract")
            }
        }
        },
    
    toChemicals() {
      this.$router.push("/chemicals");
      this.selectIndex = 4;
    },
    toIndex() {
      this.$router.push("/");
      this.selectIndex = 1;
      
    },
    topRescription() {
      this.$router.push("/prescription");
      this.seachKey='';
      this.SET_SEACH_KEY(this.seachKey)
      this.selectIndex = 2;
      this.selectedValue=2;
    },
    togoodsList() {
      this.$router.push("/goodslist");
      this.seachKey='';
      this.SET_SEACH_KEY(this.seachKey)
      this.selectIndex = 5;
      this.selectedValue=1;
    },
    toExtract() {
      this.$router.push("/extract");
      this.seachKey='';
      this.SET_SEACH_KEY(this.seachKey)
      this.selectIndex = 3;
      this.selectedValue=3;
    },
    toLogin() {
      toLogin(this);
    },
    toCar() {
      console.log(111);
      if (this.userId == "") {
        toLogin(this);
        this.$message.error("请先登录后查看");
      } else {
        this.$router.push("/car");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  >
.iheader {
  width: 100%;
  height: 168px;
  box-sizing: border-box;
}
.syimg{
  height: 50px;
  width: 50px;
  /* border: 1px solid #2b2b2b;
  border-radius: 50%; */
}
.iheader_pad {
  width: 100%;
  margin: 0 auto;
}

.iheaderp_d1 {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  margin-top: 19px;
}

.iheaderp_d1 img {
  width: 300px;
  height: 80px;
  margin-right: 80px;
  float: left;
}

.iheaderpd1_d2 {
  float: left;
  padding-top: 14px;
}
.iheaderpd1_d3 {
  float: left;
  padding-top: 14px;
  padding-left: 130px;
}
.iheaderpd1d3_left {
  width: 120px;
  height: 40px;
  color: white;
  background: #3f3b3b;
  float: left;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
}
.iheaderpd1d3_left a {
  width: 120px;
  height: 40px;
  float: left;
}

.iheaderpd1d3_right {
  float: right;
  width: 40px;
  height: 40px;
  color: white;
  background: #bb2524;
  text-align: center;
  line-height: 40px;
}
.iheaderpd1d3_right img {
  float: left;
  width: 20px;
  height: 20px;
  padding: 10px 0 0 10px;
}
.cartsize a{
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  border: 1px solid #bb2524;
  background-color: #bb2524;
  color: white;
  position: relative;
  top: 5px;
  left: -10px;

}
.iheaderpd1_d2 ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.iheaderpd1d2_top {
  width: 450px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #999999;
  overflow: hidden;
}
.searchSelect {
  float: left;
  width: 70px;
  height: 40px;
  border: 1px solid #ccc;
  line-height: 40px;
}

.iheaderpd1d2_bot {
  font-size: 12px;
  color: #999999;
  margin-top: 13px;
  margin-left: 4px;
}

.iheaderpd1d2_bot a {
  margin-right: 21px;
}

.iheaderpd1d2_top input {
  background: none;
  outline: none;
  border: none;
  float: left;
  height: 38px;
  line-height: 38px;
  margin-left: 15px;
  font-size: 15px;
}

.iheaderpd1d2_top a {
  float: right;
  height: 40px;
  width: 80px;
  background-color: #cf3737;
  color: #fff;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
}

.iheaderp_d2 {
  width: 100%;
  height: 46px;
  margin: auto;
  line-height: 46px;
  font-size: 18px;
  background: #2b2b2b;
  margin-top: 20px;
  float: none;
  text-align: center;
}

.iheaderpd2_a2 {
  display: inline-block;
  height: 46px;
  padding: 0 20px;
  margin: auto;
  color: #fcfcfc;
}

.iheaderpd2_a2_select {
  background-color: #dd2a2a;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>